import { isNil } from 'lodash';

const CHAT_QUERY_SELECTOR = '.embeddedServiceHelpButton .helpButton .uiButton';

/*
 * Add Salesforce script to the page, but only include the scripts
 * if the user has chat enabled.
 */
function initScript(user) {
  if (isNil(user) || !user.isChatEnabled) {
    return;
  }

  const INIT_CHAT = initEsw(user);

  if (!isNil(window.embedded_svc)) {
    return INIT_CHAT('https://service.force.com');
  }

  const FURTHER_CHAT_SCRIPT_EL = document.createElement('script');
  FURTHER_CHAT_SCRIPT_EL.setAttribute(
    'src',
    process.env.VUE_APP_SALESFORCE_CHAT_SCRIPT_URL,
  );

  FURTHER_CHAT_SCRIPT_EL.onload = function() {
    INIT_CHAT(null);
  };
  document.body.appendChild(FURTHER_CHAT_SCRIPT_EL);
}

/*
 * Function used to initalize Salesforce Chat configuration. This function
 * is expecting the user object comes from REST-002.
 */
function initEsw(user) {
  return function(gslbBaseURL) {
    embedded_svc.settings.language = 'en-US';
    embedded_svc.settings.defaultMinimizedText = 'Chat with Further';
    embedded_svc.settings.disabledMinimizedText =
      'Chat is not available at this time';
    embedded_svc.settings.enabledFeatures = ['LiveAgent'];
    embedded_svc.settings.entryFeature = 'LiveAgent';
    embedded_svc.settings.extraPrechatFormDetails = [
      {
        label: 'SAMKeyUnique Id',
        value: String(user.memberId),
        transcriptFields: [],
        displayToAgent: true,
      },
      {
        label: 'First Name',
        value: user.firstName,
        transcriptFields: [],
        displayToAgent: true,
      },
      {
        label: 'Last Name',
        value: user.lastName,
        transcriptFields: [],
        displayToAgent: true,
      },
      {
        label: 'Email',
        value: user.emailAddress,
        transcriptFields: [],
        displayToAgent: true,
      },
      {
        label: 'issue',
        value: 'Customer Chat',
        transcriptFields: [],
        displayToAgent: true,
      },
      {
        label: 'Case Origin',
        value: 'Chat',
        transcriptFields: [],
        displayToAgent: true,
      },
      {
        label: 'rt',
        value: String(process.env.VUE_APP_SALESFORCE_RECORD_TYPE),
        transcriptFields: [],
        displayToAgent: true,
      },
    ];

    embedded_svc.settings.extraPrechatInfo = [
      {
        entityName: 'Contact',
        showOnCreate: true,
        linkToEntityName: 'Case',
        linkToEntityField: 'ContactId',
        saveToTranscript: 'ContactId',
        entityFieldMaps: [
          {
            isExactMatch: true,
            fieldName: 'MB_Key__c',
            doCreate: false,
            doFind: true,
            label: 'SAMKeyUnique Id',
          },
          {
            isExactMatch: true,
            fieldName: 'FirstName',
            doCreate: false,
            doFind: false,
            label: 'First Name',
          },
          {
            isExactMatch: true,
            fieldName: 'LastName',
            doCreate: false,
            doFind: false,
            label: 'Last Name',
          },
          {
            isExactMatch: true,
            fieldName: 'Email',
            doCreate: false,
            doFind: false,
            label: 'Email',
          },
        ],
      },
      {
        entityName: 'Case',
        showOnCreate: true,
        saveToTranscript: 'CaseId',
        entityFieldMaps: [
          {
            isExactMatch: false,
            fieldName: 'Subject',
            doCreate: true,
            doFind: false,
            label: 'issue',
          },
          {
            isExactMatch: false,
            fieldName: 'Origin',
            doCreate: true,
            doFind: false,
            label: 'Case Origin',
          },
          {
            isExactMatch: false,
            fieldName: 'RecordTypeId',
            doCreate: true,
            doFind: false,
            label: 'rt',
          },
          /*
           * The lines below are a potential work around that may be needed.
           * Salesforce dev will let us know if this is needed, added here for
           * ease of addition if that time comes.
           */
          // {
          //   isExactMatch: false,
          //   fieldName: 'SAMKey__c',
          //   doCreate: true,
          //   doFind: false,
          //   label: 'SAMKeyUnique Id',
          // },
        ],
      },
    ];

    embedded_svc.init(
      process.env.VUE_APP_SALESFORCE_BASE_URL,
      process.env.VUE_APP_SALESFORCE_LIVE_AGENT_SETUP_FLOW_URL,
      gslbBaseURL,
      process.env.VUE_APP_SALESFORCE_ORG_ID,
      'Chat_Agents',
      {
        baseLiveAgentContentURL:
          process.env.VUE_APP_SALESFORCE_BASE_LIVE_AGENT_CONTENT_URL,
        deploymentId: process.env.VUE_APP_SALESFORCE_DEPLOYMENT_ID,
        buttonId: process.env.VUE_APP_SALESFORCE_BUTTON_ID,
        baseLiveAgentURL: process.env.VUE_APP_SALESFORCE_BASE_LIVE_AGENT_URL,
        eswLiveAgentDevName: 'Chat_Agents',
        isOfflineSupportEnabled: false,
      },
    );
  };
}

export { CHAT_QUERY_SELECTOR, initEsw, initScript };
